import { styled } from "@mui/material/styles";

export const LoadingContainer = styled("div")`
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
